import React, { useState, useEffect } from "react";
import Drawer from "@material-ui/core/Drawer";
import { userMessageService } from "./_services/userMessage.service";
import { skip } from "rxjs/operators/index";
import { makeStyles} from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import {
  AdMessageWorkerWithSocket,
  BusMessageWorkerWithSocket,
  SysMessageWorkerWithSocket,
} from "./MessageWorkerComponent";
import {
  faChevronDown,

} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withStyles } from "@material-ui/core/styles";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import Badge from "@material-ui/core/Badge";
import { Tooltip } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import backOverlap from '../assets/images/overlaps/messages_component/overlap_back.png';
import adOverlap from '../assets/images/overlaps/messages_component/overlap_ad.png';
import sysOverlap from '../assets/images/overlaps/messages_component/overlap_sys.png';
import busOverlap from '../assets/images/overlaps/messages_component/overlap_bus.png';
import messagesHeaderBg from '../assets/images/backgrounds/bg_messages_header.png';
import OverlapBottom from '../assets/images/overlaps/messages_component/overlap_bottom.png';
const useStyles = makeStyles((theme) => ({
  drawer: {
    width: "20vw",
    flexShrink: 0,
  },
  drawerPaper: {
    width: "20vw",
    minWidth: '300px',
    height: "calc(90vh - 64px)!important",
    marginTop: 'calc(5vh + 64px)',
    background: 'none',
    border: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'center',
    overflow: 'hidden',

  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    position: 'relative',
    flexDirection: 'row-reverse',
    alignSelf: 'flex-end',
    width: '100%',
    height: '60px',
    justifyContent: "flex-start",
  },
  rootScroll: {
    position: "fixed",
    bottom: theme.spacing(0),
    right: theme.spacing(0),
  },
  badge: {
    cursor: "pointer",
    margin: theme.spacing(0),
  },
  Tooltip: {
    padding: 0,
    position: "absolute",
    right: "15%",
  },
  backOverlap: {
    position: 'absolute',
    height: '165%',
    top: 0,
    left: 0,
    transform: "translate(-2%,-15%)",
    "& > img": {
      height: '100%',
      filter: 'drop-shadow(-5px 5px 5px #555)',
      pointerEvents: "none",
    },
    '&:hover':{
      cursor: 'pointer',
    }
  },
  drawerContainer: {
    width: "90%",
    height: "95%",
    alignSelf: 'flex-end'
  },
  drawerHeaderContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    minWidth: '200px',
    width: '90%',
    background: "url(" + messagesHeaderBg + ")",
    backgroundSize: '90% 100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition:'center right'
  },
  messageAccordion: {
    borderRadius: 0,
    borderTopLeftRadius: '0 !important',
    borderBottomLeftRadius: '0 !important',
    borderTopRightRadius: '0 !important',
    borderBottomRightRadius: '0 !important',
    border: 'none',
    padding: 0,
  },
  messageOverlap: {
    position: 'absolute',
    height: '135%',
    top: 0,
    left: 0,
    transform: "translate(-25%,7%)",
    "& > img": {
      height: '100%',
      filter: 'drop-shadow(3px 0px 3px #555)',
      pointerEvents: "none",
      
    }
  },
  messageOverlapBottom: {
    "& > img": {
      filter: 'none',
      pointerEvents: "none",
    }
  },
  messageTitle: {
    paddingLeft: "70px",
    color: '#57585A',
    fontFamily: "Poppins",

  },
  drawerContent: {
    backgroundColor: 'white',
    height: 'calc(100% - 50px)',
    paddingTop: '30px',
    borderTopLeftRadius: '10px',
    borderBottomLeftRadius: '10px',
    borderLeft: '1px solid black',
    borderBottom: '1px solid black',
  }
}));

const Accordion = withStyles({
  root: {
    boxShadow: "none",
    marginBottom: "15px",
    marginTop: "15px",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: 0,
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: "#ECECEE",
    minHeight: '50px',
    "&$expanded": {
      minHeight: '50px',
    },
  },
  content: {
    "&$expanded": {
      margin: "0 0",
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(0),
  },
}))(MuiAccordionDetails);

const MessagesComponent = () => {
  const classes = useStyles();
  const [state, setState] = useState({ open: false });
  const [sysMessageCounter, setSysMessageCounter] = useState(0);
  const [adMessageCounter, setAdMessageCounter] = useState(0);
  const [busMessageCounter, setBusMessageCounter] = useState(0);
  const [expandedItem, setExpandedItem] = useState('ad');
  useEffect(() => {
    const subscription = userMessageService
      .getDrawerComponentMessage()
      .pipe(skip(1))
      .subscribe((d) => {
        setState((state) => ({ ...state, open: d.open }));
      });
    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    const adSubscription = userMessageService
      .getAdMessageCounterMessage()
      .pipe(skip(1))
      .subscribe((m) => {
        setAdMessageCounter(m.counter);
      });
    return () => {
      adSubscription.unsubscribe();
    };
  }, []);

  useEffect(() => {
    const busSubscription = userMessageService
      .getBusMessageCounterMessage()
      .pipe(skip(1))
      .subscribe((m) => {
        setBusMessageCounter(m.counter);
      });
    return () => {
      busSubscription.unsubscribe();
    };
  }, []);

  useEffect(() => {
    const sysSubscription = userMessageService
      .getSysMessageCounterMessage()
      .pipe(skip(1))
      .subscribe((m) => {
        setSysMessageCounter(m.counter);
      });
    return () => {
      sysSubscription.unsubscribe();
    };
  }, []);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState((state) => ({ ...state, open: open }));
    userMessageService.toggleDrawer();
      
  };
  const handleChangePanel = (panel) => (event, isExpanded) => {
    setExpandedItem(panel);
  };
  return (
    <Drawer
      className={classes.drawer}
      anchor="right"
      open={state.open}
      variant="persistent"
      onClose={toggleDrawer(false)}
      classes={{
        paper: classes.drawerPaper,
      }}
    >


      <div className={classes.drawerContainer}>
        <div className={classes.drawerHeader}>
          <Box component='div' onClick={toggleDrawer(false)} className={classes.backOverlap}>
            <img src={backOverlap} alt="zakładka" />
          </Box>
          <div className={classes.drawerHeaderContent}>
          </div>
        </div>
        <div className={classes.drawerContent}>

          <Accordion
            className={classes.messageAccordion}
            expanded={expandedItem === "ad"}
            onChange={handleChangePanel("ad")}>
            <AccordionSummary
              expandIcon={
                <FontAwesomeIcon
                  size={"xs"}
                  aria-label={"Expand documents list"}
                  icon={faChevronDown}
                />
              }
              aria-controls="user-documents-content"
              id="user-documents-header"
            >
              <Box component='div' className={classes.messageOverlap}>
                <img src={adOverlap} alt="zakładka" />
              </Box>
              <Box component='div' className={classes.messageOverlap + ` ` + classes.messageOverlapBottom}>
                <img src={OverlapBottom} alt="zakładka" />
              </Box>
              <Box component='div' className={classes.messageTitle}>

                <Badge badgeContent={adMessageCounter} color="secondary">
                    OGŁOSZENIA
                </Badge>

              </Box>
              <Tooltip title={"Odczytaj wszystkie ogłoszenia"} aria-label={"readAll"} className={classes.Tooltip}>
                <IconButton onClick={(e) => { e.stopPropagation(); userMessageService.messageComponentUpdateMessage(2); }}>
                  <MailOutlineIcon />
                </IconButton>
              </Tooltip>
            </AccordionSummary>
            <AccordionDetails>
                <AdMessageWorkerWithSocket />
            </AccordionDetails>
          </Accordion>



          <Accordion
            className={classes.messageAccordion}
            expanded={expandedItem === "bus"}
            onChange={handleChangePanel("bus")}>
            <AccordionSummary
              expandIcon={
                <FontAwesomeIcon
                  size={"xs"}
                  aria-label={"Expand documents list"}
                  icon={faChevronDown}
                />
              }
              aria-controls="user-documents-content"
              id="user-documents-header"
            >
              <Box component='div' className={classes.messageOverlap}>
                <img src={busOverlap} alt="zakładka" />
              </Box>
              <Box component='div' className={classes.messageOverlap + ` ` + classes.messageOverlapBottom}>
                <img src={OverlapBottom} alt="zakładka" />
              </Box>
              <Box component='div' className={classes.messageTitle}>

              <Badge badgeContent={busMessageCounter} color="secondary">
                  FIRMOWE 
              </Badge>
              </Box>
              <Tooltip title={"Odczytaj wszystkie wiadomości firmowe"} aria-label={"readAll"} className={classes.Tooltip}>
                <IconButton onClick={(e) => { e.stopPropagation(); userMessageService.messageComponentUpdateMessage(1); }}>
                  <MailOutlineIcon />
                </IconButton>
              </Tooltip>
            </AccordionSummary>
            <AccordionDetails>
                <BusMessageWorkerWithSocket />
            </AccordionDetails>
          </Accordion>


          <Accordion
            className={classes.messageAccordion}
            expanded={expandedItem === "sys"}
            onChange={handleChangePanel("sys")}>
            <AccordionSummary
              expandIcon={
                <FontAwesomeIcon
                  size={"xs"}
                  aria-label={"Expand documents list"}
                  icon={faChevronDown}
                />
              }
              aria-controls="user-documents-content"
              id="user-documents-header"
            >
              <Box component='div' className={classes.messageOverlap}>
                <img src={sysOverlap} alt="zakładka" />
              </Box>
              <Box component='div' className={classes.messageOverlap + ` ` + classes.messageOverlapBottom}>
                <img src={OverlapBottom} alt="zakładka" />
              </Box>
              <Box component='div' className={classes.messageTitle}>

              <Badge badgeContent={sysMessageCounter} color="secondary">
                  SYSTEMOWE 
              </Badge>
              </Box>
              <Tooltip title={"Odczytaj wszystkie wiadomości systemowe"} aria-label={"readAll"} className={classes.Tooltip}>
                <IconButton onClick={(e) => { e.stopPropagation(); userMessageService.messageComponentUpdateMessage(3); }}>
                  <MailOutlineIcon />
                </IconButton>
              </Tooltip>
            </AccordionSummary>
            <AccordionDetails>
                <SysMessageWorkerWithSocket />
            </AccordionDetails>
          </Accordion>
        </div>
      </div>
      
    </Drawer>
  );
};

export default MessagesComponent;
